/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("checkModule", []).
controller("checkCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'item', 'trsconfirm', "$document","$timeout", "newTopicRuleService", function($scope, $modalInstance, trsHttpService, item, trsconfirm, $document,$timeout,newTopicRuleService) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            //suc:false,//成功弹层
        };
        $scope.data = {
            items: item,
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        checkData();
    }
    /**
     * [deleteData description] 删除数据请求
     */
    function checkData() {
        var params = {
             "typeid": 'screen',
             "serviceid": 'zjsentimentrulemgr',
             "modelid": 'getrule',
             'id':$scope.data.items.id,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.checkCont = data;
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [del description] 删除弹窗
     * @return {[type]} [description]
     */
    $scope.del = function(id) {
        newTopicRuleService.del(id).then( function(data){
            if(data == true){
                $modalInstance.close(true);
            }
        });
    }
    /**
     * [editrule description] 编辑弹窗
     * @return {[type]} [description]
     */
    $scope.editrule = function(id) {
        newTopicRuleService.editrule(id).then( function(data){
            if(data == true){
                $modalInstance.close(true);
            }
        });
    }

}]);